import {get} from '@stencil/megatron';

export default async function getVoyagerPagemakerTemplate({templates = []}) {
    const host = 'https://voyager.goibibo.com';
    const path = `/api/v1/pagemaker/get_rendered_template/?template_ids=${JSON.stringify(templates)}`;
    const {data} = await get(`${host}${path}`, {name: `voyager-${templates}`});
    if (data) {
        const {data: tempData} = data;
        const finalData = templates.map(i => tempData[i].template);
        return finalData;
    }
}